import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Method = () => {
  const { t } = useLanguage();
  const steps = t("method.steps");
  return (
    <section
      id="method"
      data-testid="method-section"
      className="relative py-28 sm:py-40 bg-[#0A1420]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="max-w-2xl"
        >
          <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-6">
            {t("method.eyebrow")}
          </p>
          <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl leading-tight text-white">
            {t("method.title")}
            <span className="gold-gradient-text italic">{t("method.titleAccent")}</span>
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`method-step-${i}`}
              className="group bg-[#0A1420] p-8 sm:p-10 transition-colors duration-500 hover:bg-[#0B1622]"
            >
              <span className="font-serif-lux text-6xl text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.4)]">
                0{i + 1}
              </span>
              <div className="mt-6 h-px w-10 bg-[#D4AF37]/50 transition-all duration-500 group-hover:w-16" />
              <h3 className="mt-6 font-serif-lux text-2xl text-white">{s.title}</h3>
              <p className="mt-3 text-[#A0ABC0] font-light leading-relaxed text-sm">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
